const map = {
	"./aland-islands.svg": 2473,
	"./albania.svg": 9818,
	"./algeria.svg": 4231,
	"./american-samoa.svg": 3930,
	"./anguilla.svg": 7157,
	"./argentina.svg": 2225,
	"./armenia.svg": 8863,
	"./australia.svg": 6688,
	"./austria.svg": 5267,
	"./azerbaijan.svg": 3997,
	"./bahrain.svg": 7049,
	"./belarus.svg": 5894,
	"./belgium.svg": 5869,
	"./bolivia.svg": 9366,
	"./bosnia-and-herzegovina.svg": 6333,
	"./botswana.svg": 6235,
	"./brazil.svg": 3644,
	"./bulgaria.svg": 5405,
	"./cambodia.svg": 5324,
	"./cameroon.svg": 4754,
	"./canada.svg": 5272,
	"./chile.svg": 5989,
	"./china.svg": 3239,
	"./colombia.svg": 1968,
	"./costa-rica.svg": 4260,
	"./croatia.svg": 3221,
	"./cuba.svg": 3277,
	"./cyprus.svg": 5064,
	"./czech-republic.svg": 404,
	"./denmark.svg": 3488,
	"./ecuador.svg": 4683,
	"./egypt.svg": 7879,
	"./estonia.svg": 7947,
	"./ethiopia.svg": 8911,
	"./finland.svg": 5934,
	"./france.svg": 7427,
	"./georgia.svg": 7794,
	"./germany.svg": 437,
	"./greece.svg": 1567,
	"./haiti.svg": 8485,
	"./hong-kong.svg": 5022,
	"./hungary.svg": 2720,
	"./iceland.svg": 4500,
	"./india.svg": 2827,
	"./indonesia.svg": 7392,
	"./iran.svg": 7514,
	"./iraq.svg": 5293,
	"./ireland.svg": 6359,
	"./israel.svg": 5214,
	"./italy.svg": 5079,
	"./ivory-coast.svg": 9176,
	"./japan.svg": 762,
	"./kazakhstan.svg": 8780,
	"./kuwait.svg": 3961,
	"./latvia.svg": 4155,
	"./liechtenstein.svg": 2517,
	"./lithuania.svg": 8799,
	"./luxembourg.svg": 8870,
	"./malaysia.svg": 6119,
	"./mexico.svg": 1819,
	"./mongolia.svg": 848,
	"./montenegro.svg": 6560,
	"./nauru.svg": 9301,
	"./netherlands.svg": 2174,
	"./nicaragua.svg": 1123,
	"./nigeria.svg": 8527,
	"./norway.svg": 7668,
	"./pakistan.svg": 4679,
	"./panama.svg": 9842,
	"./paraguay.svg": 9706,
	"./peru.svg": 8592,
	"./philippines.svg": 4879,
	"./portugal.svg": 612,
	"./puerto-rico.svg": 1167,
	"./republic-of-macedonia.svg": 6280,
	"./republic-of-poland.svg": 8545,
	"./romania.svg": 5119,
	"./russia.svg": 217,
	"./serbia.svg": 1840,
	"./singapore.svg": 8384,
	"./slovakia.svg": 7118,
	"./slovenia.svg": 8019,
	"./south-africa.svg": 3428,
	"./south-korea.svg": 6420,
	"./spain.svg": 9737,
	"./sri-lanka.svg": 1680,
	"./sweden.svg": 602,
	"./switzerland.svg": 2189,
	"./taiwan.svg": 7134,
	"./thailand.svg": 7943,
	"./tunisia.svg": 1661,
	"./turkey.svg": 504,
	"./ukraine.svg": 4201,
	"./united-arab-emirates.svg": 2121,
	"./united-kingdom.svg": 3907,
	"./united-states-of-america.svg": 7783,
	"./united-states.svg": 5242,
	"./uruguay.svg": 2470,
	"./venezuela.svg": 7207,
	"./vietnam.svg": 1898
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1506;